import React from 'react'
import { StyleService } from '@src/style/service'
import { Text } from '@src/components/base/Text'
import { Icon } from '@src/components/base/Icon'
import { useStyleSheet } from '@style/service.ts'
import { MyPlanCard } from '@screens/Home/components/MyPlan/MyPlanCard.tsx'

interface PaidVideoCallCreditsBannerProps {
  primaryText: string
  secondaryText: string
  paidCallCreditCount: number
  handleOnPress: () => void
}

export const PaidCallCreditsCard = ({
  primaryText,
  secondaryText,
  handleOnPress,
  paidCallCreditCount,
}: PaidVideoCallCreditsBannerProps) => {
  const styles = useStyleSheet(themedStyle)

  return (
    <MyPlanCard
      leftAccessory={
        paidCallCreditCount === 0 ? (
          <Icon name="bell-ringing" size="26" weight="bold" style={styles.bellIcon} />
        ) : (
          <Text type="large" bold>
            {paidCallCreditCount}
          </Text>
        )
      }
      primaryText={primaryText}
      secondaryText={secondaryText}
      handleOnPress={handleOnPress}
    />
  )
}

const themedStyle = StyleService.create({
  numberContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 28,
    height: 56,
    width: 56,
    backgroundColor: 'theme.surface.base3',
    alignSelf: 'center',
  },
  bellIcon: {
    color: 'theme.marketing.onText',
  },
})
